import type { Theme } from "@mui/material";
import type { DataGridPremiumComponents } from "@mui/x-data-grid-premium/themeAugmentation";
import * as MUIDataGridLocales from "@mui/x-data-grid-premium/locales";

const DataGrid = (
  theme: Theme,
  locale: keyof typeof MUIDataGridLocales
): DataGridPremiumComponents<Omit<Theme, "components">> => {
  return {
    MuiDataGrid: {
      defaultProps: {
        localeText:
          MUIDataGridLocales[locale].components.MuiDataGrid.defaultProps
            .localeText,
        rowHeight: 48,
        pagination: false,
        hideFooterRowCount: true,
        ignoreDiacritics: true,
        hideFooterSelectedRowCount: true,
        autosizeOptions: {
          includeHeaders: true,
          includeOutliers: true,
          expand: true,
        },
        density: "comfortable",
        pageSizeOptions: [10],
        initialState: {
          pinnedColumns: {
            right: ["actions"],
          },
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        },
        slotProps: {
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
          },
        },
      },
      styleOverrides: {
        root: {
          boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)",
          borderRadius: "13px",
          borderColor: theme.palette.grey[200],
          gap: "4px",
          "--DataGrid-overlayHeight": "calc(100vh - 500px)",
          ".MuiDataGrid-actionsCell": {
            button: {
              width: 26,
              height: 26,
              borderRadius: "8px",
              svg: {
                width: 26,
                height: 26,
              },
            },
          },
          "--DataGrid-rowBorderColor": theme.palette.indigo[100],
          ".MuiDataGrid-filler--pinnedRight": {
            borderLeft: 0,
          },
          ".MuiDataGrid-footerContainer ": {
            height: "80px",
          },
        },
        columnHeader: {
          border: "unset!important",
        },
        withBorderColor: {
          borderTopColor: theme.palette.indigo[100],
        },
        columnHeaderTitle: {
          fontWeight: 700,
          fontSize: "16px",
          overflow: "unset",
          textOverflow: "unset",
          whiteSpace: "initial",
        },
        columnSeparator: {
          display: "none",
        },
        cell: {
          borderTop: "1px solid",
          borderTopColor: theme.palette.indigo[100],
          fontSize: "13.975px",
          fontWeight: 600,
          borderLeft: 0,
          ":nth-of-type(odd)": {
            fontWeight: 400,
          },
          display: "flex",
          alignItems: "center",
          whiteSpace: "normal",
          overflow: "visible",
          lineHeight: "normal",
          "&--rendered": {
            boxAlign: "center",
            lineHeight: "inherit",
          },
        },
      },
    },
  };
};

export default DataGrid;
